import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_REAL_ESTATE_PRODUCT_INVESTMENT } from "../../../config/api";

export const createRealEstateInvestment = createAsyncThunk(
  "investment-Real-Estate/create",
  async ({ data, navigate, setSubmitting, type }, { rejectWithValue }) => {
    try {
      const response = await Client({
        method: "POST",
        path: API_REAL_ESTATE_PRODUCT_INVESTMENT,
        data: data,
        contentType: "multipart/form-data",
        serializerConfig: { indexes: null },
      });
      if (type === "first-cycle") {
        toast.success("Investment Product created successfully");
        navigate(-1);
      } else {
        toast.success("The investment has been successfully created");
        navigate("/investment", { replace: true });
      }
      return response?.data;
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg);
      setSubmitting(false);
      return rejectWithValue(error.message);
    }
  }
);
